exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-798c17e7] .el-dialog__title {\n  font-size: 25px;\n  color: #606266;\n}\n", ""]);

// exports
